<template>
  <div class="oracle">
    <menuBox :step="1"></menuBox>
    <div class="oracle-box">
      <div class="banner-text">
        <div class="title">หน้าต่างสู่อนาคต การสร้างสรรค์อันชาญฉลาด</div>
        <div class="text">
          บริษัท ORACLE LIFE ครอบคลุมอุตสาหกรรมหลักสี่อุตสาหกรรม: เกษตรกรรม สิ่งทอ เครื่องใช้ในบ้าน และเครื่องปรุงรส
          บริษัทมุ่งมั่นที่จะสร้างสรรค์นวัตกรรมและคุณภาพและแสวงหาความเป็นเลิศ
          วิสัยทัศน์ของเราคือการมอบผลิตภัณฑ์ที่ยอดเยี่ยมแก่ลูกค้า และสร้างอนาคตสีเขียวผ่านเทคโนโลยีขั้นสูง
        </div>
      </div>
    </div>
    <div class="company-box">
      <div class="title">ออราเคิล ไลฟ์</div>
      <div class="text">ธุรกิจของเรา</div>
      <div class="company-content">
        <div class="company-left">
          <div :class="type == 1 ? 'itemActive' : 'item'" @click="changeType(1)">
            <div class="imgBox">
              <img src="../assets/company1.png" alt="">
            </div>
            <div class="line" v-if="type != 1">
            </div>
            <p>สินค้าทางการเกษตร</p>
          </div>
          <div :class="type == 2 ? 'itemActive' : 'item'" @click="changeType(2)">
            <div class="imgBox">
              <img src="../assets/company2.png" alt="">
            </div>
            <div class="line" v-if="type != 2">
            </div>
            <p>สิ่งทอ</p>
          </div>
          <div :class="type == 3 ? 'itemActive' : 'item'" @click="changeType(3)">
            <div class="imgBox">
              <img src="../assets/company3.png" alt="">
            </div>
            <div class="line" v-if="type != 3">
            </div>
            <p>เครื่องใช้ในบ้าน</p>
          </div>
          <div :class="type == 4 ? 'itemActive' : 'item'" @click="changeType(4)">
            <div class="imgBox">
              <img src="../assets/company4.png" alt="">
            </div>
            <div class="line" v-if="type != 4">
            </div>
            <p>เครื่องปรุงรส</p>
          </div>
        </div>
        <div class="company-right">
          <div class="bt" v-if="type == 1">สินค้าทางการเกษตร</div>
          <div class="bt" v-if="type == 2">สิ่งทอ</div>
          <div class="bt" v-if="type == 3">เครื่องใช้ในบ้าน</div>
          <div class="bt" v-if="type == 4">เครื่องปรุงรส</div>
          <div class="rightTitle" v-if="type == 1">
            มุ่งเน้นไปที่การเพาะปลูกและการจัดหาผลิตภัณฑ์ทางการเกษตรคุณภาพสูงโดยใช้เทคโนโลยีการเกษตรที่ยั่งยืนเพื่อให้มั่นใจในความปลอดภัยของอาหารและการปกป้องสิ่งแวดล้อม
          </div>
          <div class="rightTitle" v-if="type == 2">
            จัดหาสิ่งทอที่หลากหลาย ผสมผสานงานฝีมือแบบดั้งเดิมเข้ากับการออกแบบที่ทันสมัย
            ​​โดยมุ่งเน้นที่การใช้วัสดุที่เป็นมิตรต่อสิ่งแวดล้อมและเทคโนโลยีที่เป็นนวัตกรรม
          </div>
          <div class="rightTitle" v-if="type == 3">
            ผลิตเครื่องใช้ในบ้านที่ทันสมัยและประหยัดพลังงาน มุ่งมั่นที่จะปรับปรุงคุณภาพชีวิต
            และแสวงหานวัตกรรมทางเทคโนโลยีและปรับปรุงประสบการณ์ผู้ใช้อย่างต่อเนื่อง
          </div>
          <div class="rightTitle" v-if="type == 4">
            พัฒนาเครื่องปรุงรสให้หลากหลายรสชาติ ใช้วัตถุดิบคุณภาพสูง ผสมผสานเทคนิคการปรุงรสแบบดั้งเดิมและสมัยใหม่
            เพื่อให้คนรักอาหารมีทางเลือกมากมาย
          </div>
          <div class="pesoloan">
            <!-- <div class="leftBox">
              <div class="item" v-for="item in 4">
                <span></span>
                <p>1111111111111111111111</p>
              </div>
            </div> -->
            <img src="../assets/fruit.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="landscape-box">
      <div class="left">
        <img src="../assets/landscape.png" alt="">
        <div class="content">
          <div class="bt">Helping centers 24/7<br> hours open.</div>
          <div class="us">Contact Us :</div>
          <div class="us">+123-4567-8910</div>
          <div class="us">hmend@gmail.com</div>
        </div>
      </div>
      <div class="right">
        <div class="bt">ความรับผิดชอบต่อสังคม</div>
        <div class="text">ORACLE LIFE มีความรับผิดชอบต่อสังคมอย่างลึกซึ้งและมุ่งมั่นที่จะปกป้องสิ่งแวดล้อม
          การอนุรักษ์พลังงาน และการลดการปล่อยก๊าซเรือนกระจก
          มีส่วนร่วมอย่างแข็งขันในกิจกรรมการกุศลของชุมชนและส่งเสริมการพัฒนาภูมิภาค
          นอกจากนี้ยังให้ความสำคัญกับสุขภาพและการเติบโตของพนักงาน และยึดมั่นในการค้าที่เป็นธรรมและจริยธรรม
          การจัดซื้อจัดจ้างเพื่อให้มั่นใจในห่วงโซ่อุปทานทั้งหมด ความยั่งยืน</div>
        <div class="itemBox">
          <div class="item">
            <div class="line"></div>
            <p>การคุ้มครองสิ่งแวดล้อม: ดำเนินการอนุรักษ์พลังงานและลดการปล่อยก๊าซเรือนกระจก
              และส่งเสริมความตระหนักรู้ด้านสิ่งแวดล้อม</p>
          </div>
          <div class="item">
            <div class="line"></div>
            <p>การสนับสนุนชุมชน: เข้าร่วมกิจกรรมการกุศลและส่งเสริมการพัฒนาภูมิภาค</p>
          </div>
        </div>
        <div class="itemBox">
          <div class="item">
            <div class="line"></div>
            <p>ความเป็นอยู่ที่ดีของพนักงาน: รับประกันสภาพแวดล้อมการทำงานที่ดี รวมถึงฝึกอบรมและพัฒนาพนักงาน</p>
          </div>
          <div class="item">
            <div class="line"></div>
            <p>ห่วงโซ่อุปทานที่ยั่งยืน: ใช้การค้าที่เป็นธรรมและการจัดซื้อจัดจ้างอย่างมีจริยธรรม</p>
          </div>
        </div>
      </div>
    </div>
    <div class="services-box">
      <div class="title">ออราเคิล ไลฟ์</div>
      <div class="text">ธุรกิจของเรา</div>
      <div class="content">
        <div class="item">
          <div class="imgBox">
            <img src="../assets/services1.png" class="services" alt="">
            <img src="../assets/wall1.png" class="wall" alt="">
          </div>
          <div class="titleBox">
            <p>การประกันคุณภาพ</p>
            <span>ใช้มาตรฐานระดับสูงเพื่อให้แน่ใจว่าผลิตภัณฑ์มีคุณภาพสูงและเชื่อถือได้</span>
          </div>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/services2.png" class="services" alt="">
            <img src="../assets/wall2.png" class="wall" alt="">
          </div>
          <div class="titleBox">
            <p>ขับเคลื่อนด้วยนวัตกรรม</p>
            <span>การวิจัยและพัฒนาอย่างต่อเนื่อง การแสวงหาเทคโนโลยีและนวัตกรรมการออกแบบ</span>
          </div>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/services3.png" class="services" alt="">
            <img src="../assets/wall3.png" class="wall" alt="">
          </div>
          <div class="titleBox">
            <p>การดูแลลูกค้า</p>
            <span>ให้บริการส่วนบุคคลเพื่อตอบสนองความต้องการของลูกค้า</span>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    changeType(val) {
      this.type = val
    }
  },
};
</script>

<style lang="less" scoped>
.oracle-box {
  background-image: url(../assets/swiper-1.png);
  height: 640px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    margin-left: 360px;
    padding-top: 180px;
    width: 600px;

    .title {
      margin-bottom: 24px;
      font-size: 48px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .text {
      font-size: 18px;
      font-family: ArialMT;
      color: #333333;
    }
  }
}

.company-box {
  padding: 120px 360px;

  .title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-family: ArialMT;
    color: #F56604;
  }

  .text {
    text-align: center;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: normal;
    color: #333333;
  }

  .company-content {
    margin-top: 56px;
    display: flex;
    align-items: center;

    .company-left {
      .item {
        width: 600px;
        display: flex;
        align-items: center;
        background: #1D2735;
        border: 1px solid #929292;
        cursor: pointer;
        .imgBox {
          position: relative;
          width: 100px;
          height: 100px;

          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 64px;
            height: 64px;
          }
        }

        .line {
          width: 1px;
          height: 40px;
          background: #D8D8D8;
        }

        p {
          width: 500px;
          padding: 40px 30px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }

      .itemActive {
        width: 600px;
        display: flex;
        align-items: center;

        .imgBox {
          position: relative;
          width: 100px;
          height: 100px;
          background: #F56604;

          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 64px;
            height: 64px;
          }
        }

        p {
          width: 500px;
          background: #FFFFFF;
          box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
          padding: 40px 30px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #F56604;
        }
      }
    }

    .company-right {
      padding: 40px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);

      .bt {
        margin-bottom: 10px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #F56604;
      }

      .rightTitle {
        font-size: 14px;
        font-family: ArialMT;
        color: #333333;
      }

      .pesoloan {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;

        img {
          margin-top: 26px;
          width: 318px;
          height: 191px;
        }

        .leftBox {
          .item {
            margin-bottom: 20px;
            display: flex;
            align-items: center;

            span {
              margin-right: 8px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #F56604;
            }
          }
        }
      }
    }
  }
}

.landscape-box {
  display: flex;

  .left {
    position: relative;

    img {
      width: 960px;
      height: 640px;
    }

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 420px;
      height: 332px;
      padding: 60px 40px;
      background: #F56604;
      box-sizing: border-box;

      .bt {
        margin-bottom: 22px;
        color: #FFFFFF;
        padding-bottom: 22px;
        font-size: 26px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        border-bottom: 1px solid #fff;
      }

      .us {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        color: #FFFFFF;
        line-height: 30px;
      }
    }
  }

  .right {
    flex: 1;
    padding: 130px 80px;
    background: #F6F6F6;

    .bt {
      margin-bottom: 50px;
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .text {
      margin-bottom: 40px;
      font-size: 14px;
      font-family: ArialMT;
      color: #333333;
    }

    .itemBox {
      display: flex;
      align-items: center;
      margin-bottom: 22px;

      .item {
        width: 50%;
        display: flex;
        align-items: center;
        margin-right: 34px;

        .line {
          margin-right: 8px;
          width: 2px;
          height: 52px;
          background: #F56604;
        }

        p {
          font-size: 14px;
          font-family: ArialMT;
          color: #999999;
          line-height: 26px;

        }
      }
    }
  }
}

.services-box {
  padding: 120px 360px;

  .title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-family: ArialMT;
    color: #F56604;
  }

  .text {
    text-align: center;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: normal;
    color: #333333;
  }

  .content {
    margin-top: 56px;
    display: flex;

    .item {
      margin-right: 45px;

      .imgBox {
        position: relative;
        width: 370px;
        height: 248px;

        .services {
          width: 370px;
          height: 248px;
        }

        .wall {
          position: absolute;
          left: 50%;
          bottom: -30px;
          transform: translate(-50%, 0);
          width: 60px;
          height: 60px;
        }
      }

      .titleBox {
        width: 370px;
        padding: 40px 32px;
        box-sizing: border-box;
        text-align: center;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);

        p {
          margin-bottom: 10px;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        span {
          font-size: 16px;
          font-family: ArialMT;
          color: #333333;
          line-height: 24px;
        }
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}</style>
